import { FieldDependency } from '../../types/form/schema.types';

export const createShowWhenEqualsDependency = (
  field: string,
  value: unknown
): FieldDependency => ({
  type: 'show',
  logicalOperator: 'AND',
  conditions: [
    {
      field,
      operator: 'equals',
      value,
    },
  ],
});

export const createShowWhenEqualsAnyDependency = (
  field: string,
  values: readonly unknown[]
): FieldDependency => ({
  type: 'show',
  logicalOperator: 'OR',
  conditions: values.map((value) => ({
    field,
    operator: 'equals',
    value,
  })),
});
